import { arrayMap } from "./array.utils";

export function objEntries(obj) {
  return Object.entries(obj);
}

export function objectToQueryString(params) {
  return arrayMap(Object.keys(params), (key) => {
    if (params[key] !== null && typeof params[key] !== "undefined") {
      if (Array.isArray(params[key])) {
        // Encode each array element separately with the same key
        return (
          arrayMap(
            params[key],
            (val) => `${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`
          ) || []
        ).join("&");
      } else {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      }
    } else {
      return "";
    }
  })
    .filter((param) => param !== "")
    .join("&");
}
